import * as yup from "yup";

export default (messages) => {
  return yup.object().shape({
    username: yup.string().required(messages.REQUIRED),
    password: yup.string().required(messages.REQUIRED),
    passwordConfirm: yup.string().when("password", {
      is: (val) => val && val.length > 0,
      then: yup.string().oneOf([yup.ref("password")], messages.MISMATCH),
    }),
  });
};
